import { getChromeExtensionOrigin } from '@/utils/isInChromeExtension';

/**
 * Returns a function that opens a chrome://settings page.
 *
 * When running inside the extension side panel, chrome:// URLs can't be opened
 * directly from web content, so we postMessage the extension which calls
 * chrome.tabs.create on our behalf. Outside the extension we have no way to
 * open chrome:// URLs, so we return null to let the caller fall back to
 * showing the URL as copyable text.
 */
const useChromeSettings = () => {
  const extensionOrigin = getChromeExtensionOrigin();

  const isInExtension = extensionOrigin?.startsWith('chrome-extension://') ?? false;

  const openSettings = isInExtension
    ? (url: string) => {
        window.parent.postMessage({ type: 'OPEN_SETTINGS', url }, extensionOrigin!);
      }
    : null;

  const extensionSettingsUrl = isInExtension
    ? `chrome://settings/content/siteDetails?site=${encodeURIComponent(extensionOrigin!)}`
    : null;

  const siteSettingsUrl = `chrome://settings/content/siteDetails?site=${encodeURIComponent(window.location.origin)}`;

  return { openSettings, extensionSettingsUrl, siteSettingsUrl, isInExtension };
};

export default useChromeSettings;
